const wixInstanceId = '33750584-5cda-44e1-8738-62a9139347b3';

const WixPolyfill = {
  navigateToPage: () => {},
  getSiteMap: () => ({}),
  getPublicAPI: () => {},
  addEventListener: () => {},
  removeEventListener: () => {},
  currentMember: (cb: Function) => cb(null),
  refreshCurrentMember: () => {},
  requestLogin: () => {},
  logOutCurrentMember: () => {},
  replaceSectionState: () => {},
  closeWindow: () => {},
  setHeight: () => {},
  resizeComponent: () => {},
  WindowOrigin: {},
  WindowPlacement: {},
  getCurrentPageId: (cb: Function) => cb('pageId'),
  getSitePages: () => [{ id: '/' }],
  getSiteInfo: () => {},
  scrollTo: () => {},
  setPageMetadata: () => {},
  isAppSectionInstalled: () => false,
  SuperApps: {
    getPublicAPI: (_args: object, onSuccess: (res: object) => void) => {
      setTimeout(() => {
        onSuccess({
          startPrivateChat: () => {},
        });
      }, 200);
    },
  },
  Events: {
    SITE_SAVED: 'SITE_SAVED',
    SITE_PUBLISHED: 'SITE_PUBLISHED',
    SETTINGS_UPDATED: 'SETTINGS_UPDATED',
    MEMBER_DETAILS_UPDATED: 'MEMBER_DETAILS_UPDATED',
    INSTANCE_CHANGED: 'INSTANCE_CHANGED',
  },
  Styles: {
    getSiteTextPresets: () => {},
    getSiteColors: () => {},
    getStyleFontByReference: () => ({}),
    getStyleParams: () => ({}),
    setUILIBParamValue: () => {},
  },
  PubSub: {
    publish: () => {},
    subscribe: () => {},
    unsubscribe: () => {},
  },
  Utils: {
    getCompId: () => 'comp-00000000j',
    getOrigCompId: () => '0000000j',
    getUid: () => '00000000-0000-0000-0000-000000000001',
    getSectionUrl: () => `${window.location.protocol}//${window.location.host}/`,
    getInstanceId: () => wixInstanceId,
    getInstanceValue: () => '00000000-0000-0000-0000-000000000000',
    getViewMode: () => '',
    navigateToSection: () => {},
    getWidth: () => {},
  },
  Performance: {
    applicationLoaded: () => {},
  },
  Settings: {
    triggerSettingsUpdatedEvent: () => {},
    refreshApp: () => {},
  },
  Data: {
    Public: {
      set: () => {},
      get: () => {},
    },
  },
};

export const instanceId = wixInstanceId;

export default (typeof window !== 'undefined' && window.Wix ? window.Wix : WixPolyfill) as Wix;
